import { render, staticRenderFns } from "./cardDetailDialog.vue?vue&type=template&id=58578e01&scoped=true&"
import script from "./cardDetailDialog.vue?vue&type=script&lang=js&"
export * from "./cardDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./cardDetailDialog.vue?vue&type=style&index=0&id=58578e01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58578e01",
  null
  
)

export default component.exports